import * as signalR from '@microsoft/signalr';
import { signalRConfig } from '@/config';

/**
 * Create a SignalR HubConnection with authentication
 */
export const createSignalRConnection = (
  getAccessToken: () => Promise<string | null>
): signalR.HubConnection => {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(signalRConfig.hubUrl, {
      accessTokenFactory: async () => {
        const token = await getAccessToken();
        return token || '';
      },
    })
    .withAutomaticReconnect([...signalRConfig.reconnectDelays])
    .configureLogging(signalR.LogLevel.Information)
    .build();

  return connection;
};

export type SignalRConnection = signalR.HubConnection;
export { HubConnectionState } from '@microsoft/signalr';
